export function optimizeCustomTimings(customTimings, interactionStart) {
  return customTimings.reduce(function (result, item) {
    Object.keys(item.data).forEach(function (key) {
      if (item.data[key].startTime >= interactionStart) {
        result.push({
          labelStack: [{
            n: key
          }],
          startTime: Math.round(item.data[key].startTime),
          endTime: Math.round(item.data[key].endTime)
        });
      }
    });
    return result;
  }, []);
}